import { toast } from "react-toastify";
import store from "../../store/Index";

const getToastTheme = () => store.getState().theme.mode === "dark" ? "dark" as const : "light" as const;

export const showSuccessToast = (message: string) => {
  const isDark = store.getState().theme.mode === "dark";
  toast.success(message, {
    position: "top-right",
    autoClose: 6000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: getToastTheme(),
    style: {
      backgroundColor: isDark ? "#111827" : "#fff",
      color: isDark ? "#f0f4f8" : "#333",
      border: "1px solid #614438",
      zIndex: 9999,
      borderRadius: "12px",
      boxShadow: isDark ? "0 8px 32px rgba(0,0,0,0.4)" : "0 8px 32px rgba(0,0,0,0.1)",
    },
  });
};

export const showErrorToast = (
  message: string,
  toastId: string = "error-toast"
) => {
  const isDark = store.getState().theme.mode === "dark";
  toast.dismiss(toastId);
  toast.error(message, {
    toastId,
    position: "top-right",
    autoClose: 7000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: getToastTheme(),
    style: {
      backgroundColor: isDark ? "#111827" : "#fff",
      color: isDark ? "#f0f4f8" : "#333",
      border: "1px solid #C29363",
      zIndex: 10000,
    },
    role: "alert",
  });
};
